import { IFinanceOperatorsItem } from 'entities/financeOperations/types';

export const useUpdateFinanceOperationsDefaultValues = (financeOperation: IFinanceOperatorsItem) => ({
  commission_min: financeOperation.commission_min,
  commission_percent: financeOperation.commission_percent,
  limit: financeOperation.limit,
  city_ids: financeOperation.city_ids,
  is_needed_validation: financeOperation.is_needed_validation,
});
